import React, { Component } from 'react';
import http, { subscribeShopDataSyncState } from '../modules/api';
import axios from 'axios';

import DisplayHomePopup from './component/DisplayHomePopup';
import WarningDialog from '../modules/dialogs/WarningDialog';

class DisplayHome extends Component {
  hasFetchedSyncData = false;
  syncTimer = null;
  constructor(props) {
    super(props);

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      
      if (parts.length === 2) {
        return parts.pop().split(';').shift();
      }
      return null; // 쿠키가 없을 경우
    }

    this.state = {
      standby_yn: "",
      syncState: "",
      syncDateFormat: "",
      sync_date_full_format: "",

      /** 타이틀 컨텐츠 다이얼로그 state */
      showSaveTitleContentDialog: false,
      titleContentDialogTitle: "",
      titleContentDialogContent: "",
      titleContentDialogButtonList: [{
          title : "확인",
          event_method : () => { alert("확인 버튼을 누르셨습니다.") }
      },{
          title : "취소",
          event_method : () => { this.handleToggle("show_save_title_content_dialog") }
      }],

      /** 무료 체험 기간 조회 */
      remain_date: "0",
      start_day_of_week: "",
      start_date_format: "",
      end_day_of_week: "",
      end_date_format: "0000.00.00",
      is_finish: "",
      payment_yn: "",
      payment_cls_text: "무료체험 남은 기간",

      /** 쇼핑몰별 연결된 진열 영역 개수 */
      install_cnt: "0",
      install_cnt_format: "0",
      install_cnt_load_yn: "N",

      /** 쇼핑몰별 총 알고리즘 설정 개수 */
      manual_json_cnt: "0",
      manual_json_cnt_format: "0",

      /** 진열홈 팝업 노출 여부 */
      showDisplayHomePopup: false,

      /** 경고 다이얼로그 */
      show_warning_dialog: false,
      warning_dialog_content: "",

      /** 솔루션 타입 코드 */
      solution_type_cd: getCookie('solution_type_cd'),

      /** 사용자 키워드 설정 여부 */
      is_user_category_method: false,
    };
  }

  componentDidMount() {
    this.loadShopSyncStateAndSyncDate();
    this.loadFreeDatePeriod();
    this.loadRpEventConnectionCnt();
    this.loadRpEventItemSettingMnualJson();
    this.handleLoadCategoryMethod();

    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  componentWillUnmount() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    if (this.syncTimer) clearTimeout(this.syncTimer);
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      // [포그라운드] 화면에 돌아오면 즉시 최신 데이터 호출 (타이머도 이 안에서 다시 시작됨)
      console.log("화면 복귀: 데이터 즉시 갱신");
      this.loadShopSyncStateAndSyncDate(false);
    } else {
      // [백그라운드] 화면에서 사라지면 타이머 정지 (API 호출 중단)
      if (this.syncTimer) {
        console.log("백그라운드 진입: 타이머 일시 정지");
        clearTimeout(this.syncTimer);
      }
    }
  }

  /** 플랫폼 API 연동 상태 조회 및 자동 갱신 스케줄링 */
  loadShopSyncStateAndSyncDate = (is_sync_date_check_and_sync_start) => {
    // 기존에 예약된 타이머가 있다면 취소 (중복 호출 방지)
    if (this.syncTimer) clearTimeout(this.syncTimer);

    http.get("/rest/shop/shopSyncStateAndSyncDate")
      .then(res => {
        if (res.data != null && res.data != '') {
          // 1. 상태 업데이트
          this.setState({
            syncState: res.data.sync_state,
            syncDateFormat: res.data.sync_date_format,
            sync_date_full_format: res.data.sync_date_full_format,
            standby_yn: res.data.standby_yn
          }, () => {
            // 2. 상태 반영 후 다음 호출 스케줄링 실행 (자동 갱신 로직)
            this.scheduleNextPoll(res.data.sync_state);
          });

          // 3. 버튼 클릭 등으로 인한 수동 호출일 경우의 알림/팝업 로직
          if (is_sync_date_check_and_sync_start == true) {
            if (res.data.sync_state == "1") {
              alert("상품 목록을 불러오는 중입니다. 완료될 때까지 기다려 주세요.\n" +
                "상품 수에 따라 짧게는 몇 분에서 길게는 몇 시간이 걸릴 수 있습니다.");
            } else {
              // 상품 연동 확인 팝업
              this.setState({
                showSaveTitleContentDialog: true,
                titleContentDialogTitle: "상품 목록을 새로 불러오시겠습니까?",
                titleContentDialogContent: "<p style=\"word-break:keep-all;\">상품 수에 따라 짧게는 몇 분에서 길게는 몇 시간이 걸릴 수 있습니다.</br>" +
                  "그 동안 다른 기능들은 모두 정상적으로 이용하실 수 있습니다.</p>",
                titleContentDialogButtonList: [{
                    title: "네",
                    event_method: () => {
                      this.fn_refreshDataSync();
                      this.setState({
                        showSaveTitleContentDialog: false
                      })
                    }
                  },
                  {
                    title: "아니요",
                    event_method: () => {
                      // 팝업 닫기
                      this.setState({
                        showSaveTitleContentDialog: false
                      })
                    }
                  },
                ],
              })
            }
          }
        }
      })
      .catch(error => {
        console.error(error);
        // 에러 발생 시에도 1분 뒤 재시도 (필요 시 주석 처리 가능)
        // this.scheduleNextPoll("error"); 
      });
  }

  fn_refreshDataSync  = () => {
      const {syncState} = this.state;
      try {
          this.hasFetchedSyncData = true;
          if (syncState !== "1") {
            this.setState({
                syncState: "1"
            })
          };

          axios.post('/rest/shop/refreshDataSyncShop', {
              // api_seq: "4,5,15" // 15: 방문자 수 API
              // api_seq: "4,5,1" // 1: 상품 API (컬러 옵션도 여기서 수집함)
              // api_seq: "20" // 20: 함께 구매한 상품용 주문 API
              // api_seq: "16" // 16: 조회수
              // api_seq: "18" // 18: 장바구니 수
              // api_seq: "19" // 19: 주문수
              // api_seq: "4,5" 
              // api_seq: "21" // 시간별 주문 통계
              // api_seq: "4,5,10,11" // 리뷰 수집
          }, {
              headers: {
                  'Connection' : 'keep-alive',
                  'Keep-Alive' : 'timeout=40000',
                  'X-requested-With' : 'XMLHttpRequest',
                  'Content-type': 'application/json;',
              }
          })
          .then(res => {
              /** 최초 호출시 cafe24API 호출 connection timeout 외 예외 발생시 */
              if (!res || res.data.code !== 200) {
                  if (this.hasFetchedSyncData) {
                      throw new Error('ERR_EMPTY_RESPONSE')
                  }
              } else {
                  /** 200/OK */
                  this.loadShopSyncStateAndSyncDate()
              }
          })
          .catch(error => {
              /** 서버 타임아웃 */
              subscribeShopDataSyncState(new Date().getTime())
                  .then(res => this.callBackSubscribeShopDataSyncState(res))
          })   
      } catch (err) {
          console.error(err)
      }
  }

  callBackSubscribeShopDataSyncState = (res) => {
      this.hasFetchedSyncData = false
      if (res === 0) return
      if (res === true) {
        this.setState({
            syncState: "0"
        })
      }
      else if (typeof res === "string"){
          /** 시간초과 || 서버 메세지*/
          console.log(res)
      } else {
          /** response.data 없을 경우 */
          console.err(res)
      }
  }

  /** 다음 API 호출 스케줄링 */
  scheduleNextPoll = (syncState) => {
    // 1. [중요] 백그라운드 상태라면 스케줄링을 하지 않고 종료
    //    (나중에 handleVisibilityChange가 'visible'이 될 때 다시 호출해줍니다)
    if (document.hidden) {
        return;
    }

    // 2. 연동 중("1")이면 자동 갱신 중단 (이전 요청사항)
    if (syncState == "1") {
      return;
    }

    // 3. 1분 뒤 재호출 예약
    this.syncTimer = setTimeout(() => {
      // 타임아웃 실행 시점에도 한번 더 체크 (혹시 그 사이 백그라운드로 갔을 수 있음)
      if (!document.hidden) {
          this.loadShopSyncStateAndSyncDate(false);
      }
    }, 60000);
  }

  formatRelativeTime(dateString) {
  if (!dateString) return '';

  dateString = dateString.replaceAll(".", "-");

  const start = new Date(dateString);
  const end = new Date();

  const seconds = Math.floor((end.getTime() - start.getTime()) / 1000);

  if (seconds < 60) return '방금 전';

  const minutes = seconds / 60;
  if (minutes < 60) return `${Math.floor(minutes)}분 전`;

  const hours = minutes / 60;
  if (hours < 24) return `${Math.floor(hours)}시간 전`;

  const days = hours / 24;
  if (days < 7) return `${Math.floor(days)}일 전`;

  // 👇 날짜 직접 포맷
  const y = start.getFullYear();
  const m = String(start.getMonth() + 1).padStart(2, '0');
  const d = String(start.getDate()).padStart(2, '0');

  return `${y}.${m}.${d}`;
}

  /** 무료 체험 기간 조회 */
  loadFreeDatePeriod = () => {
      http.get("/rest/shop/rp/freeDatePeriod")
      .then(res => {
          // console.log(res.data);
      if (res.data != null && res.data != '') {
        let start_date = res.data["start_date_format"];
        start_date = start_date.replace("년","-");
        start_date = start_date.replace("월","-");
        start_date = start_date.replace("일","");
        start_date = start_date.replace(/ /gi,"");

        let end_date = res.data["end_date_format"];
        // end_date = end_date.replace("년","-");
        // end_date = end_date.replace("월","-");
        // end_date = end_date.replace("일","");
        // end_date = end_date.replace(/ /gi,"");

        let payment_yn = res.data["payment_yn"];
        let payment_cls_text = "";
        if (payment_yn == 'Y') {
            payment_cls_text = "유료 이용 기간";
        } else {
            payment_cls_text = "무료체험 남은 기간";
        }

        this.setState({
          remain_date: res.data["remain_date"],
          start_day_of_week: res.data["start_day_of_week"],
          start_date_format: start_date,
          end_day_of_week: res.data["end_day_of_week"],
          end_date_format: end_date,
          is_finish: res.data["is_finish"],
          payment_yn: res.data["payment_yn"],
          payment_cls_text: payment_cls_text,
        })

        if (res.data["remain_date"] && parseInt(res.data["remain_date"]) <= -8) {
            // setTitleContentDialogZindex("10001");
            // setShowSaveTitleContentDialog(true);
            // setTitleContentDialogTitle("무료체험 연장 신청");
            // setTitleContentDialogContent("오랜만에 재방문 하셨군요?<br/>무료체험 연장 신청을 하시겠습니까?")
            // setTitleContentDialogButtonList([
            //     {
            //         title:"신청하러 가기",
            //         event_method: () => {
            //             window.open("https://docs.google.com/forms/d/e/1FAIpQLSd7svi27m5_3nOV_qLtPwcuP174aAT-ybk66wKRQvW45ZZ5Ww/viewform?usp=sf_link");
            //             setShowSaveTitleContentDialog(false);
            //             setTitleContentDialogZindex("");
            //         }
            //     },
            //     {
            //         title: "아니요",
            //         event_method: () => {
            //             //팝업 닫기
            //             setShowSaveTitleContentDialog(false);
            //             setTitleContentDialogZindex("");
            //         }
            //     },
            // ])

            this.setState({
              showSaveTitleContentDialog: true,
              showFreeTrialExtenssionDialogState: false,
              tutorialDialogState: false
            })
        }
    }
  })
  .catch(error => {
          console.log("#freeDatePeriodError",error)
    });
  }

  /** 쇼핑몰별 연결된 진열 영역 개수 조회 */
  loadRpEventConnectionCnt =() => {
      http.get("/rest/shop/rp/event/connection/cnt")
  .then(res => {
    if (res.data != null && res.data != '') {
      let install_cnt = res.data["install_cnt"];
      let install_cnt_format = res.data["install_cnt_format"];

      this.setState({
        install_cnt: install_cnt,
        install_cnt_format: install_cnt_format,
        install_cnt_load_yn: "Y"
      })
    } else {
      this.setState({
        install_cnt: 0,
        install_cnt_format: 0,
        install_cnt_load_yn: "Y"
      })
    }
  })
  .catch(error => {
     this.setState({
        install_cnt: 0,
        install_cnt_format: 0,
        install_cnt_load_yn: "Y"
      })
  });
  }

  /** 총 알고리즘 설정수 조회 */
  loadRpEventItemSettingMnualJson = () => {
    http.get("/rest/shop/rp/event/setting/manualJsonCnt")
    .then(res => {
            // console.log(res.data);
      if (res.data != null && res.data != '') {
        let manual_json_cnt = res.data["cnt"];
        let manual_json_cnt_format = res.data["cnt_format"];

        this.setState({
          manual_json_cnt: manual_json_cnt,
          manual_json_cnt_format: manual_json_cnt_format
        })
      }
    })
    .catch(error => {
    });
  }

  openDisplayHomePopup() {
    if (this.state.solution_type_cd != "09001") {
      this.setState({
        show_warning_dialog: true,
        warning_dialog_content: "해당 기능은<br/>Cafe24 솔루션에서만<br/>사용 가능합니다."
      })

      return;
    }

    this.setState({
      showDisplayHomePopup: true,
    });
  }
  
  closeDisplayHomePopup() {
    this.setState({
      showDisplayHomePopup: false,
    });
  }

  // 사용자의 키워드 조회 (GET)
  handleLoadCategoryMethod = () => {
      http.get('/rest/shop/rp/user-category-method')
      .then(res => {
      if (res.data.code == 200) {
          this.setState({
              is_user_category_method: res.data.category_cd && res.data.method_cd ? true : false,
          });
      } else {
          this.setState({
              is_user_category_method: false,
          });
      }
      })
      .catch(err => {
      console.error('키워드 조회 에러:', err);
      this.setState({
          is_user_category_method: false,
      });
      });
  }

  render() {
    const { 
      standby_yn, 
      syncState, 
      sync_date_full_format, 
      payment_cls_text, 
      remain_date, 
      end_date_format,
      install_cnt,
      install_cnt_format,
      install_cnt_load_yn,
      manual_json_cnt,
      manual_json_cnt_format, 
      showDisplayHomePopup,
      solution_type_cd,
      is_user_category_method,
    } = this.state;

    return (
      <>
        <style>{`
          /* --- CSS Scoping: #robo-main-before --- */
          #robo-main-before {
            --color-mint: #00e2e6;
            --color-mint-hover: #00bfc2;
            --color-navy: #0A1A2F;
            --color-navy-light: #1f2937;
            --color-gray-bg: #f9fafb;
            --color-blue: #3b82f6; /* 연동중 아이콘 색상 */
            --color-blue-bg: #eff6ff; /* 연동중 배지 배경 */
            
            --shadow-card: 0 4px 20px rgba(0,0,0,0.06);
            --shadow-hover: 0 10px 25px rgba(0,226,230,0.15);
            
            font-family: 'Noto Sans KR', sans-serif;
            background-color: var(--color-gray-bg);
            padding: 24px;
            flex: 1;
            overflow-y: auto;
          }

          #robo-main-before .main-inner { max-width: 1280px; margin: 0 auto; display: flex; flex-direction: column; gap: 40px; }

          /* Hero Section */
          #robo-main-before .hero {
            background-color: var(--color-navy); border-radius: 24px; padding: 32px;
            color: #fff; position: relative; overflow: hidden;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.25);
            display: flex; flex-direction: column; justify-content: space-between; gap: 32px;
            margin-top: 8px;
          }
          #robo-main-before .hero-bg {
            position: absolute; top: 0; right: 0; width: 600px; height: 600px;
            background-color: var(--color-mint); opacity: 0.1; filter: blur(64px);
            border-radius: 50%; transform: translate(33%, -50%); pointer-events: none;
          }
          #robo-main-before .hero-content { position: relative; z-index: 10; max-width: 670px; }

          @keyframes pulse-green { 0%, 100% { opacity: 1; } 50% { opacity: .5; } }
          #robo-main-before .badge-live {
            display: inline-flex; align-items: center; gap: 8px; padding: 4px 12px;
            border-radius: 999px; background-color: rgba(34, 197, 94, 0.2);
            border: 1px solid rgba(34, 197, 94, 0.3); color: #4ade80;
            font-size: 12px; font-weight: 700; margin-bottom: 16px;
            backdrop-filter: blur(4px);
            animation: pulse-green 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          }

          #robo-main-before .badge {
            display: inline-flex; align-items: center; gap: 8px; padding: 4px 12px;
            border-radius: 999px; background-color: rgba(255,255,255,0.1);
            border: 1px solid rgba(255,255,255,0.2); color: var(--color-mint);
            font-size: 12px; font-weight: 700; margin-bottom: 16px; backdrop-filter: blur(4px);
          }
          #robo-main-before .hero h1 { font-size: 30px; font-weight: 700; line-height: 1.3; margin-bottom: 16px; margin-top: 0; }
          #robo-main-before .hero h1 span { color: var(--color-mint); }
          #robo-main-before .hero p { color: #d1d5db; font-size: 18px; line-height: 1.5; margin: 0; }
          
          #robo-main-before .btn-cta {
            background-color: var(--color-mint); color: var(--color-navy);
            font-weight: 700; font-size: 20px; padding: 24px 40px; border-radius: 16px;
            box-shadow: 0 4px 20px rgba(0,226,230,0.4); display: flex; align-items: center; gap: 12px;
            transition: transform 0.2s; position: relative; z-index: 10; border: none; cursor: pointer;
          }
          #robo-main-before .btn-cta:hover { background-color: var(--color-mint-hover); transform: translateY(-4px); }

          /* Stats Grid */
          #robo-main-before .grid-4 { display: grid; grid-template-columns: repeat(1, 1fr); gap: 24px; }
          #robo-main-before .card {
            background: #fff; padding: 24px; border-radius: 16px;
            box-shadow: var(--shadow-card); border: 1px solid #e5e7eb;
            display: flex; flex-direction: column; height: 100%;
            justify-content: space-between;
          }
          #robo-main-before .card-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px; }
          #robo-main-before .card-title { font-size: 14px; font-weight: 700; color: #6b7280; margin: auto 0; }
          .card-title { margin-bottom: 0px; }

          /* Status Badges */
          .card-header { background-color: #fff; padding: 0; border-bottom: 0px solid #e5e7eb; }
          #robo-main-before .status-badge { background-color: #f3f4f6; color: #6b7280; font-size: 12px; padding: 4px 10px; border-radius: 4px; font-weight: 700; }
          #robo-main-before .status-badge.linking { background-color: var(--color-blue-bg); color: var(--color-blue); }
          #robo-main-before .status-badge-green { background-color: #dcfce7; color: #15803d; font-size: 12px; padding: 4px 10px; border-radius: 4px; font-weight: 700; }

          #robo-main-before .card-value { font-size: 30px; font-weight: 700; color: var(--color-navy); margin-bottom: 4px; }
          #robo-main-before .card-value span { font-size: 18px; font-weight: 400; color: #9ca3af; }
          #robo-main-before .card-desc { font-size: 14px; color: #9ca3af; margin-top: 8px; display: flex; justify-content: space-between; align-items: center; }
          .card-desc { margin-bottom: 0px; }
          #robo-main-before .link-mint { color: var(--color-mint); font-weight: 700; font-size: 14px; text-decoration: none; }
          #robo-main-before .link-mint:hover { text-decoration: underline; }

          #robo-main-before .btn-connect {
            width: 100%; background-color: var(--color-navy); color: #fff;
            font-size: 14px; font-weight: 700; padding: 12px 16px; border-radius: 12px;
            display: flex; align-items: center; justify-content: center; gap: 8px;
            transition: background 0.2s, box-shadow 0.2s; border: none; cursor: pointer;
          }
          #robo-main-before .btn-connect:hover { background-color: var(--color-navy-light); box-shadow: 0 4px 6px rgba(0,0,0,0.1); }

          /* Linking State Styles (New) */
          #robo-main-before .linking-body { display: flex; flex-direction: column; justify-content: space-between; height: 100%; }
          #robo-main-before .linking-indicator { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
          #robo-main-before .icon-spin { font-size: 32px; color: var(--color-blue); animation: spin 1.5s linear infinite; }
          #robo-main-before .text-linking { font-size: 24px; font-weight: 700; color: var(--color-navy); }
          #robo-main-before .btn-disabled {
            width: 100%; background-color: #f3f4f6; color: #9ca3af;
            font-size: 16px; font-weight: 700; padding: 12px 16px; border-radius: 12px;
            border: none; cursor: not-allowed; text-align: center;
          }

          .active_text { color: #0A1A2F !important; }
          
          @keyframes spin { 
            0% { transform: rotate(0deg); } 
            100% { transform: rotate(360deg); } 
          }

          /* Features Grid */
          #robo-main-before .section-title { font-size: 20px; font-weight: 700; color: var(--color-navy); margin-bottom: 20px; display: flex; align-items: center; gap: 8px; }
          #robo-main-before .grid-3 { display: grid; grid-template-columns: repeat(1, 1fr); gap: 24px; }
          
          #robo-main-before .feature-card {
            background: #fff; padding: 28px; border-radius: 16px;
            box-shadow: var(--shadow-card); border: 1px solid #e5e7eb;
            cursor: pointer; transition: all 0.2s; display: flex; flex-direction: column; height: 100%;
          }
          #robo-main-before .feature-card:hover { transform: translateY(-3px); box-shadow: var(--shadow-hover); border-color: var(--color-mint); }
          #robo-main-before .feature-card:hover .feature-title { color: var(--color-mint); }
          #robo-main-before .feature-card:hover .feature-icon-box { background-color: #eff6ff; }
          
          #robo-main-before .feature-icon-box {
            width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center;
            font-size: 20px; margin-bottom: 16px; transition: background 0.2s;
          }
          #robo-main-before .icon-blue { background-color: #eff6ff; color: #3b82f6; }
          #robo-main-before .feature-card:hover .icon-blue { background-color: #dbeafe; }
          #robo-main-before .icon-purple { background-color: #faf5ff; color: #a855f7; }
          #robo-main-before .feature-card:hover .icon-purple { background-color: #f3e8ff; }
          #robo-main-before .icon-green { background-color: #f0fdf4; color: #22c55e; }
          #robo-main-before .feature-card:hover .icon-green { background-color: #dcfce7; }
          #robo-main-before .icon-orange { background-color: #fff7ed; color: #f97316; }
          #robo-main-before .feature-card:hover .icon-orange { background-color: #ffedd5; }
          #robo-main-before .icon-indigo { background-color: #eef2ff; color: #6366f1; }
          #robo-main-before .feature-card:hover .icon-indigo { background-color: #e0e7ff; }
          #robo-main-before .icon-red { background-color: #fef2f2; color: #ef4444; }
          #robo-main-before .feature-card:hover .icon-red { background-color: #fee2e2; }

          #robo-main-before .feature-header { display: flex; align-items: center; gap: 16px; margin-bottom: 16px; }
          #robo-main-before .feature-title { font-size: 20px; font-weight: 700; color: var(--color-navy); transition: color 0.2s; margin: 0; }
          #robo-main-before .feature-desc { font-size: 16px; color: #6b7280; line-height: 1.6; margin-bottom: 24px; flex: 1; margin-top: 0; }
          
          #robo-main-before .btn-outline {
            width: 100%; background: #fff; border: 2px solid #f3f4f6; color: var(--color-navy);
            font-weight: 700; padding: 12px; border-radius: 12px; transition: all 0.2s; cursor: pointer;
          }
          #robo-main-before .feature-card:hover .btn-outline { border-color: var(--color-mint); color: var(--color-mint); }

          #displayHomePopupWrapper { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center; z-index: 10000; }

          /* Media Queries */
          @media (min-width: 768px) {
            #robo-main-before .grid-4 { grid-template-columns: repeat(2, 1fr); }
            #robo-main-before .grid-3 { grid-template-columns: repeat(2, 1fr); }
            #robo-main-before .hero { flex-direction: row; align-items: center; padding: 40px 48px; }
            #robo-main-before .hero h1 { font-size: 36px; }
          }
          @media (min-width: 1024px) {
            #robo-main-before { padding: 34px; }
            #robo-main-before .grid-4 { grid-template-columns: repeat(4, 1fr); }
            #robo-main-before .grid-3 { grid-template-columns: repeat(3, 1fr); }
          }
        `}</style>

        <div id="common-page-wrapper">

          <main id="robo-main-before">
            <div className="main-inner">
              
              {
              install_cnt_load_yn == "Y"
              ?
                install_cnt > 0
                ?
                  <section className="hero">
                    <div className="hero-bg"></div>
                    
                    <div className="hero-content">
                        <div className="badge-live">
                        <i className="fas fa-circle" style={{fontSize: '8px'}}></i> 실시간 작동 중
                        </div>
                        
                        <h1>
                        현재 <span>{install_cnt}개</span>의 자동 진열이<br />
                        완벽하게 돌아가고 있습니다.
                        </h1>
                        
                        <p>
                        아직 자동화되지 않은 영역이 남았습니다.<br />
                        <span style={{color: '#fff', fontWeight: 600}}>추가 설정</span>으로 쇼핑몰 빈틈을 자동진열로 채워보세요.
                        </p>
                    </div>

                    <div>
                        <button 
                        onClick={() => { this.openDisplayHomePopup(); }} 
                        className="btn-cta"
                        >
                        <span>🚀 업종별 맞춤 자동진열 시작하기</span>
                        </button>
                    </div>
                  </section>
                : 
                  
                    <section className="hero">
                      <div className="hero-bg"></div>
                      
                      <div className="hero-content">
                        <div className="badge">
                          <i className="fas fa-magic"></i> AI 큐레이션 엔진 2.0
                        </div>
                        <h1>
                          아직 적용된 알고리즘이 없네요.<br />
                          <span>업종</span>만 알려주시면 바로 시작할까요?
                        </h1>
                        <p>
                          복잡한 설정은 잊으세요. 업종과 고민만 선택하면 (1분 소요)<br />
                          검증된 <span style={{color: '#fff', fontWeight: 600}}>베스트·신상품 진열 공식</span>을 바로 적용해 드립니다.
                        </p>
                      </div>
                      <div>
                        <button 
                          onClick={() => { this.openDisplayHomePopup(); }} 
                          className="btn-cta"
                        >
                          <span>🚀 업종별 맞춤 자동진열 시작하기</span>
                        </button>
                      </div>
                    </section>
                : null
              }


              <section className="grid-4">
                
                {/* 1. 데이터 연동 상태 카드 (조건부 렌더링) */}
                {
                  standby_yn == "" 
                  ?
                  <div className="card" style={{borderColor: syncState == "1" ? '#e5e7eb' : '#ffedd5'}}>
                    <div className="card-header">
                      <span className="card-title">데이터 연동 상태</span>
                      <span className="status-badge">미연동</span>
                    </div>
                    <div>
                      <div className="card-value" style={{fontSize: '24px', marginBottom: '12px'}}>연동 필요</div>
                      <button 
                        className="btn-connect"
                        onClick={() => this.setState({ syncState: "1" })} // 버튼 클릭 시 연동중으로 변경 예시
                      >
                        <i className="fas fa-plug" style={{color: 'var(--color-mint)'}}></i> 데이터 연동하기
                      </button>
                    </div>
                  </div>
                  : 
                    syncState == "1" 
                    ?
                      <div className="card" style={{borderColor: syncState ? '#e5e7eb' : '#ffedd5'}}>
                        <div className="card-header">
                          <span className="card-title">데이터 연동 상태</span>
                            <span className="status-badge linking">연동중</span>
                        </div>
                        <div className="linking-body">
                          <div className="linking-indicator">
                            <i className="fas fa-sync-alt icon-spin"></i>
                            <span className="text-linking">연동 진행 중</span>
                          </div>
                          <button className="btn-disabled" disabled>
                            연동 중...
                          </button>
                        </div>
                      </div>
                    :
                      <div className="card">
                          <div className="card-header">
                          <span className="card-title">데이터 연동 상태</span>
                          <span className="status-badge-green">실시간</span>
                          </div>
                          <div>
                          <div className="card-value" style={{fontSize: '30px'}}>완료</div>
                          <p className="card-desc">마지막 업데이트: {this.formatRelativeTime(sync_date_full_format)}</p>
                          </div>
                      </div>
                }

                <div className="card">
                  <div className="card-header">
                    <span className="card-title">{payment_cls_text}</span>
                  </div>
                  <div>
                    <div className="card-value">{remain_date}<span>일</span></div>
                    <div className="card-desc">
                      <span>~ {end_date_format.replace("년 ", ".").replace("월 ", ".").replace("일", "")}</span>
                      <a href="/shop/qna/form?qna_type_cd=2104" className="link-mint">연장하기 &gt;</a>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <span className="card-title">연결된 진열 코너</span>
                  </div>
                  <div>
                    <div className={"card-value" + (
                      install_cnt > 0 ? " active_text" : ""
                    )} style={{color: '#d1d5db'}}>{install_cnt_format} <span>개</span></div>
                    <p className="card-desc">
                      {
                        install_cnt <= 0
                        ?
                        "연동 및 설정이 필요합니다."
                        : 
                        "설정된 코너가 정상 작동 중입니다."
                      }</p>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <span className="card-title">작동 중인 알고리즘</span>
                  </div>
                  <div>
                    <div className={"card-value"+ (
                      manual_json_cnt > 0 ? " active_text" : ""
                    )} style={{color: '#d1d5db'}}>{manual_json_cnt_format} <span>건</span></div>
                    <p className="card-desc">자동 진열 대기 중</p>
                  </div>
                </div>
              </section>

              <section>
                <h3 className="section-title">
                  <i className="fas fa-link" style={{color: 'var(--color-mint)'}}></i>필요한 기능으로 설정하기
                </h3>
                <div className="grid-3">
                  
                  {/* ... Feature Cards ... */}
                  <div className="feature-card" onClick={() => {
                      if (solution_type_cd != "09001") {
                        this.setState({
                          show_warning_dialog: true,
                          warning_dialog_content: "해당 기능은<br/>Cafe24 솔루션에서만<br/>사용 가능합니다."
                        })
                      } else {
                        if (is_user_category_method) {
                          window.location.href =
                          "/shop/rp/ParentAutoRpSetting" +
                          "?filter_page_id=robomd_cafe24_main_page"
                        } else {
                          this.openDisplayHomePopup();
                        }
                      }
                    }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-blue"><i className="fas fa-desktop"></i></div>
                      <h4 className="feature-title">메인 진열 자동화</h4>
                    </div>
                    <p className="feature-desc">쇼핑몰 첫 화면의 베스트·신상품 영역을 24시간 자동으로 관리합니다.</p>
                    <button className="btn-outline">연결하기</button>
                  </div>

                  <div className="feature-card" onClick={() => {
                      if (solution_type_cd != "09001") {
                        this.setState({
                          show_warning_dialog: true,
                          warning_dialog_content: "해당 기능은<br/>Cafe24 솔루션에서만<br/>사용 가능합니다."
                        })
                      } else {
                        if (is_user_category_method) {
                          window.location.href =
                          "/shop/rp/ParentAutoRpSetting" +
                          "?filter_page_id=robomd_cafe24_category_page"
                        } else {
                          this.openDisplayHomePopup();
                        }
                      }
                    }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-purple"><i className="fas fa-layer-group"></i></div>
                      <h4 className="feature-title">카테고리 진열 자동화</h4>
                    </div>
                    <p className="feature-desc">각 카테고리별로 신상품과 함께 판매를 높일 상품 순서로 자동으로 최적화합니다.</p>
                    <button className="btn-outline">연결하기</button>
                  </div>

                  <div className="feature-card" onClick={() => {
                      if (solution_type_cd != "09001") {
                        this.setState({
                          show_warning_dialog: true,
                          warning_dialog_content: "해당 기능은<br/>Cafe24 솔루션에서만<br/>사용 가능합니다."
                        })
                      } else {
                        if (is_user_category_method) {
                          window.location.href =
                          "/shop/rp/ParentAutoRpSetting" +
                          "?filter_page_id=robomd_cafe24_category_page&template_type_cd=B1008"
                        } else {
                          this.openDisplayHomePopup();
                        }
                      }
                    }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-green"><i className="fas fa-truck-fast"></i></div>
                      <h4 className="feature-title">당일발송 기획전</h4>
                    </div>
                    <p className="feature-desc">오늘 출발 가능한 상품만 자동으로 모아 기획전 코너에 자동으로 채워줍니다.</p>
                    <button className="btn-outline">연결하기</button>
                  </div>

                  <div className="feature-card" onClick={() => {
                      if (solution_type_cd != "09001") {
                        this.setState({
                          show_warning_dialog: true,
                          warning_dialog_content: "해당 기능은<br/>Cafe24 솔루션에서만<br/>사용 가능합니다."
                        })
                      } else {
                        window.location.href =
                        "/shop/rp/ParentAutoRpSettingByKeyword?step=1"
                      }
                    }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-orange"><i className="fas fa-tags"></i></div>
                      <h4 className="feature-title">키워드 기획전</h4>
                    </div>
                    <p className="feature-desc">'휴가기획전', '하객룩' 등 키워드만 고르면 테마에 맞는 상품을 자동 진열합니다.</p>
                    <button className="btn-outline">연결하기</button>
                  </div>

                  <div className="feature-card" onClick={() => {
                      if (solution_type_cd != "09001") {
                        this.setState({
                          show_warning_dialog: true,
                          warning_dialog_content: "해당 기능은<br/>Cafe24 솔루션에서만<br/>사용 가능합니다."
                        })
                      } else {
                        window.location.href =
                        "/shop/rp/event/product/statistics/cafe24"
                      }
                    }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-indigo"><i className="fas fa-chart-line"></i></div>
                      <h4 className="feature-title">상품 통계 보기</h4>
                    </div>
                    <p className="feature-desc">일자별로 진열된 상품들의 총 판매액과 구매 전환률(CVR)을 분석합니다.</p>
                    <button className="btn-outline">확인하기</button>
                  </div>

                  <div className="feature-card" onClick={() => {
                      if (solution_type_cd != "09001") {
                        this.setState({
                          show_warning_dialog: true,
                          warning_dialog_content: "해당 기능은<br/>Cafe24 솔루션에서만<br/>사용 가능합니다."
                        })
                      } else {
                        window.location.href =
                        "/shop/rp/ParentAutoRpSettingBySalePercent?step=1"
                      }
                    }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-red"><i className="fas fa-won-sign"></i></div>
                      <h4 className="feature-title">가격·할인 조건 설정</h4>
                    </div>
                    <p className="feature-desc">'1만원 이하', '50% 할인' 등 특정 조건의 상품만 필터링해 진열합니다.</p>
                    <button className="btn-outline">연결하기</button>
                  </div>

                </div>
              </section>
            </div>
          </main>
        </div>
        {
          showDisplayHomePopup &&
          <div id="displayHomePopupWrapper">
            <DisplayHomePopup
              onClose={() => { this.closeDisplayHomePopup() }}
            />
          </div>
        }
        {
            this.state.show_warning_dialog
            && <WarningDialog
                content={this.state.warning_dialog_content}
                button_list={[{
                    title : "확인",
                    event_method : () => { this.setState({show_warning_dialog: false}) }
                }]}
            />
        }
      </>
    );
  }
}

export default DisplayHome;